import "./PortfolioStyles.css"

import Project1 from "../assets/project-writer.png";
import Project2 from "../assets/project-linktree.png";
import Project3 from "../assets/project-ibice.png";

import React from 'react'

import { NavLink } from "react-router-dom";

const Portfolio = () => {
  return (

    <div className="portofolio-container">
        <h1 className="projects-heading">Proyectos recientes</h1>
        <div className="project-container">

            <div className="project-card">
                <img src={Project1} alt="Preview del proyecto"/>
                <h2 className="project-title">Portfolio literario para profesionales</h2>
                    <div className="project-buttons">
                        <NavLink to={"https://arturourbanos-portfolio.vercel.app/"} className="btn" target={"_blank"}>Visitar</NavLink>
                        <NavLink to={"https://github.com/ArturoCode/writer-portfolio"} className="btn" target={"_blank"}>Fuente</NavLink>
                    </div>
            </div>

            <div className="project-card">
                <img src={Project2} alt="Preview del proyecto"/>
                <h2 className="project-title">Linktree personalizado para creadores</h2>
                    <div className="project-buttons">
                        <NavLink to={"https://arturocode.github.io/links/"} className="btn" target={"_blank"}>Visitar</NavLink>
                        <NavLink to={"https://github.com/ArturoCode/links"} className="btn" target={"_blank"}>Fuente</NavLink>
                    </div>
            </div>

            <div className="project-card">
                <img src={Project3} alt="Preview del proyecto"/>
                <h2 className="project-title">Excursiones Íbice (empresa ficticia)</h2>
                    <div className="project-buttons">
                        <NavLink to={"https://excursiones-ibice.up.railway.app/"} className="btn" target={"_blank"}>Visitar</NavLink>
                        <NavLink to={"https://github.com/ArturoCode/excursiones-ibice"} className="btn" target={"_blank"}>Fuente</NavLink>
                    </div>
            </div>
            

        </div>
    </div>
  )
}

export default Portfolio